import { render } from "./ApplicationAgree.vue?vue&type=template&id=08c02f06"
import script from "./ApplicationAgree.vue?vue&type=script&lang=js"
export * from "./ApplicationAgree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__